import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BluebirdPromise from 'bluebird';
import { Form, reduxForm, Field, formValueSelector, submit } from 'redux-form';
import cns from 'classnames';
import { get } from 'lodash';
import { compose } from 'redux';
import BasicSearchText from '../../components/formComponents/groups/BasicSearchText';
import log from '../../utils/log';
import WithTranslation from '../../hocs/WithTranslation';
import LoadingIndicator from '../../components/LoadingIndicator';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import algolia from 'algoliasearch';
import { getSearchKey } from '../../actions';

class SearchForm extends Component {
    static propTypes = {
        className: PropTypes.string,
        searchClassName: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        onSubmit: PropTypes.func,
        handleSearchResults: PropTypes.func,
        onClearSearch: PropTypes.func,
        indexName: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        submitSearch: PropTypes.func.isRequired,
        showBottomBorder: PropTypes.bool,
        showCurrentSearchCriteria: PropTypes.bool,
        shouldRefresh: PropTypes.bool,
        showFullBorder: PropTypes.bool,
        defaultFilters: PropTypes.string,
        attributesToRetrieve: PropTypes.array,
        retrieveFullResults: PropTypes.bool,
        pathsContext: PropTypes.object,
        keyId: PropTypes.string.isRequired,
        searchKey: PropTypes.string,
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = { searchValue: '', isLoading: false };
        this.index = {};
        this.algoliaInstance = {};
        this.intervalID = ''
    }

    componentDidMount() {
      if (!this.props.searchKey) {
        this.getKey();
        this.setState({isLoading: true});
        this.intervalID = setInterval(this.getKey, 3600000);
      } else {
                this.algoliaInstance = algolia(this.context.pathsWeb.algoliaAppID, this.props.searchKey)
        this.index = this.algoliaInstance.initIndex(this.props.indexName);;
      }
    }

        componentDidUpdate(prevProps) {
      if (this.props.searchKey && prevProps.searchKey !== this.props.searchKey) {
                    this.algoliaInstance = algolia(this.context.pathsWeb.algoliaAppID, this.props.searchKey)
          this.index = this.algoliaInstance.initIndex(this.props.indexName);;
        }
      if (this.props.shouldRefresh) {
          this.handleFormSubmit({ filters: '', searchVal: this.state.searchValue });
          this.props.submitSearch();
      }
    }

    componentWillUnmount() {
      if (!this.props.searchKey) {
        clearInterval(this.intervalID);
      }
    }

        getKey = () => getSearchKey({id: this.props.keyId }, this.context.pathsWeb).then(searchKey => {
            this.algoliaInstance = algolia(this.context.pathsWeb.algoliaAppID, searchKey)
      this.index = this.algoliaInstance.initIndex(this.props.indexName);
      this.setState({isLoading: false});
    });

    handleFormSubmit = (values) => {
        const {
            onSubmit,
            handleSearchResults,
            defaultFilters,
            attributesToRetrieve = ['_id'],
            retrieveFullResults = false
        } = this.props;
        if (onSubmit) {
            onSubmit(values);
        }
        let searchResultPromise = BluebirdPromise.resolve();
        let searchOptions = {};
        const searchValue = get(values, 'searchVal', '');
        const filtersValue = get(values, 'filters', '');
        if (searchValue !== '' || filtersValue !== '') {
            searchOptions = {
                attributesToRetrieve,
                hitsPerPage: 1000
            };

            if (defaultFilters) {
                searchOptions.filters = defaultFilters;
            }

            if (filtersValue) {
                searchOptions.filters = filtersValue;
            }

            searchResultPromise = this.index.search(searchValue, searchOptions).then((result) => {
                if (retrieveFullResults) {
                    return result.hits;
                }
                return { _id: result.hits.map((hit) => hit._id) };
            });
        }

        return searchResultPromise.then((hits) => {
            const results = hits || [];
            if (handleSearchResults) {
                this.setState({ searchValue });
                const handleSearchOptions = { ...searchOptions, query: searchValue };
                handleSearchResults(results, handleSearchOptions);
            } else {
                log.warn(
                    'SearchForm.props.handleSearchResults is highly recommended since results are not being piped anywhere!'
                );
            }
        });
    };

    _onClear = () => {
        setTimeout(() => {
            this.props.submitSearch();
        }, 100);
        if (this.props.onClearSearch) {
            this.props.onClearSearch();
        }
    };

    _onSubmit = () => {
        setTimeout(() => {
            this.props.submitSearch();
        }, 100);
    };

    render() {
        const {
            handleSubmit,
            placeholder = '',
            searchClassName,
            className,
            showBottomBorder = true,
            showFullBorder = false,
            showCurrentSearchCriteria = false
        } = this.props;
        const { searchValue = null, isLoading } = this.state;

        return (
            <Form
                className={cns('col-12', { searchForm: !showFullBorder }, { 'bordered-search-form': showFullBorder })}
                onSubmit={handleSubmit(this.handleFormSubmit)}
            >
               {isLoading ? <LoadingIndicator className={'report-loading'} />:
                  <Field
                    name={'searchVal'}
                    displayHelp={false}
                    className={cns('searchInput', className)}
                    searchClassName={searchClassName}
                    showBottomBorder={showBottomBorder}
                    placeholder={placeholder}
                    onClear={this._onClear}
                    onSubmit={this._onSubmit}
                    component={BasicSearchText}
                  />
                }
                {showCurrentSearchCriteria && searchValue ? (
                    <div className={'searchResultsText'}>Search results for {`"${searchValue}"`}</div>
                ) : null}
            </Form>
        );
    }
}

export const SearchFormComponent = SearchForm;

const SearchFormValidation = {
    form: 'SearchForm'
};

const selector = formValueSelector('SearchForm');
const mapStateToProps = (state, ownProps) => ({
    initialValues: {
        filters: get(ownProps, 'precomputedFilters', '')
    },
    searchVal: selector(state, 'searchVal')
});

const mapDispatchToProps = (dispatch) => ({
    submitSearch: () => dispatch(submit('SearchForm'))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    reduxForm(SearchFormValidation)
)(WithTranslation(SearchForm));
